export enum ERouterName {
    ELEMENT = 'element',
    PROJECT = 'project',
    HOME = 'home',
    TSA = 'tsa',
    LAYER = 'layer',
    MEDIA = 'media',
    WAYLINE = 'wayline',
    LIVESTREAM = 'livestream',
    LIVING = 'living',
    WORKSPACE = 'workspace',
    MEMBERS = 'members',
    DEVICES = 'devices',
    TASK = 'task',
    CREATE_PLAN = 'create-plan',
    SELECT_PLAN = 'select-plan',
    FIRMWARES = 'firmwares',
    FLIGHT_AREA = 'flight-area',
    MISSION_EDITOR = 'mission-editor',
    OPERATORS = 'operators',
    MONITORING = 'monitoring',
    DIREKTOR = 'direktor',
    COCKPIT = 'cockpit',
    RTC_TEST = 'rtc-test',
    MOBILE = 'm',
    AI_TEST = 'ai-test',
    REPORTS = 'reports',

    PILOT = 'pilot-login',
    PILOT_HOME = 'pilot-home',
    PILOT_MEDIA = 'pilot-media',
    PILOT_LIVESHARE = 'pilot-liveshare',
    PILOT_BIND = 'pilot-bind'
}

export enum EStorageKey {
    LANG_CODE = 'DJI_CREATE_VITE_H5_APP:lang_code',
    TEST_TOOLS_POSITION_STORAGE_KEY = 'DJI_CREATE_VITE_H5_APP:test_tools_position',
    SESSION_ID = 'DJI_CREATE_VITE_H5_APP:sess'
}

export enum EStatusValue {
    CONNECTED = 'Connected',
    DISCONNECT = 'Disconnect',
    LIVING = 'Living'
}

export enum ELiveStatusValue {
    DISCONNECT,
    CONNECTED,
    LIVING
}

export enum EComponentName {
    Thing = 'thing',
    Liveshare = 'liveshare',
    Api = 'api',
    Ws = 'ws',
    Map = 'map',
    Tsa = 'tsa',
    Media = 'media',
    Mission = 'mission'
}

export enum ELocalStorageKey {
    Username = 'username',
    WorkspaceId = 'workspace_id',
    Token = 'x-auth-token',
    PlatformName = 'platform_name',
    WorkspaceName = 'workspace_name',
    WorkspaceDesc = 'workspace_desc',
    Flag = 'flag',
    UserId = 'user_id',
    Device = 'device',
    GatewayOnline = 'gateway_online',
}

export enum EPhotoType {
    Original = 0,
    Preview = 1,
    Unknown = -1
}

export enum EDownloadOwner {
    Mine = 0,
    Others = 1,
    Unknown = -1
}

export enum EUserType {
    Web = 1,
    Pilot = 2,
}

export enum EBizCode {
    GatewayOsd = 'gateway_osd',
    DeviceOsd = 'device_osd',
    DockOsd = 'dock_osd',
    MapElementCreate = 'map_element_create',
    MapElementUpdate = 'map_element_update',
    MapElementDelete = 'map_element_delete',
    DeviceOnline = 'device_online',
    DeviceOffline = 'device_offline',
    DeviceHms = 'device_hms',

    // Dock tasks
    FlightTaskProgress = 'flighttask_progress', // Dock task execution progress
    FlightTaskMediaProgress = 'file_upload_callback', // Dock task media upload progress
    FlightTaskMediaHighestPriority = 'highest_priority_upload_flighttask_media', // Dock task media priority report

    // Device commands
    DeviceReboot = 'device_reboot', // Dock restart
    DroneOpen = 'drone_open', // Aircraft power on
    DroneClose = 'drone_close', // Aircraft power off
    DeviceFormat = 'device_format', // Format dock storage
    DroneFormat = 'drone_format', // Format aircraft storage
    CoverOpen = 'cover_open', // Open dock cover
    CoverClose = 'cover_close', // Close dock cover
    PutterOpen = 'putter_open', // Extend putter
    PutterClose = 'putter_close', // Retract putter
    ChargeOpen = 'charge_open', // Start charging
    ChargeClose = 'charge_close', // Stop charging

    // Device upgrade
    DeviceUpgrade = 'ota_progress', // Device firmware upgrade

    // Device logs
    DeviceLogUploadProgress = 'fileupload_progress', // Device log upload

    // Flight command messages
    ControlSourceChange = 'control_source_change', // Control authority change
    FlyToPointProgress = 'fly_to_point_progress', // Fly to target point
    TakeoffToPointProgress = 'takeoff_to_point_progress', // One-key takeoff
    JoystickInvalidNotify = 'joystick_invalid_notify', // Device exited DRC mode
    DrcStatusNotify = 'drc_status_notify', // Flight control (DRC) mode status

    // custom flight area
    FlightAreasSyncProgress = 'flight_areas_sync_progress',
    FlightAreasDroneLocation = 'flight_areas_drone_location',
    FlightAreasUpdate = 'flight_areas_update',
}

export enum EDeviceTypeName {
    Aircraft = 0,
    Gateway = 2,
    Dock = 3,
}

export enum EHmsLevel {
    NOTICE,
    CAUTION,
    WARN,
}
